/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import {FormGroup, ValidatorFn} from '@angular/forms';

export function MustMatch(controlName: string, matchControlName: string): ValidatorFn {
  return (formGroup: FormGroup) => {
    const control = formGroup.controls[controlName];
    const matchControl = formGroup.controls[matchControlName];
    const error = {mustMatch: true};
    const hasError = matchControl && control && control.value !== matchControl.value;

    if (hasError) {
      matchControl.setErrors(error);
    }

    return hasError ? error : null;
  };
}
